import React, { useState } from "react";
import styled from "styled-components";
import { IonItemDivider, IonIcon, IonItem, IonButton } from "@ionic/react";
import { pencilOutline } from "ionicons/icons";
import strings from "../../../../res/strings";

const Container = styled.div``;

const DataDisplay = styled.div`
  border: 1px solid #dbdbdb;
  margin-bottom: 8px;
`;
const DataHeader = styled(IonItemDivider)`
  font-weight: bold;
  font-size: 0.9em;
  color: #3880ff;
`;
const EditIcon = styled(IonIcon)`
  font-size: 1.2em;
`;
const Data = styled(IonItem)`
  :hover {
    --background: #f0f5fc !important;
  }
  color: #666666;
`;

const EditComponentContainer = styled.div`
  border: 1px solid #dbdbdb;
  padding: 16px;
`;
const SaveButtonContainer = styled.div`
  padding: 4px 16px 4px 16px;
`;
const SaveButton = styled(IonButton)`
  width: 100%;
`;
const CancelButton = styled(IonButton)`
  width: 100%;
`;

const EditableDataGroupDisplay = (props) => {
  const [editing, setEditing] = useState(false);

  const handleCancel = (e) => {
    setEditing(false);
  };

  const handleClickData = (e) => {
    props.closeActiveFormEdit();
    props.openActiveFormEdit(handleCancel);
    setEditing(true);
  };

  const dataGroupDisplay = props.data.map((d, index) => {
    return (
      <DataDisplay key={index}>
        <DataHeader color="white">{d.label}</DataHeader>
        <Data lines="full" onClick={handleClickData}>
          {d.value} <EditIcon icon={pencilOutline} slot="end" />
        </Data>
      </DataDisplay>
    );
  });

  const editComponent = (
    <EditComponentContainer>
      {props.editComponent}
      <SaveButtonContainer>
        <SaveButton type="submit" color="tertiary">
          {strings.lib_common_action_save}
        </SaveButton>
        <CancelButton color="danger" onClick={handleCancel}>
          {strings.lib_common_action_cancel}
        </CancelButton>
      </SaveButtonContainer>
    </EditComponentContainer>
  );

  return <Container>{editing ? editComponent : dataGroupDisplay}</Container>;
};

export default EditableDataGroupDisplay;
